exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.statement-mobile {\r\n\tfont-size: 1.5em !important;\r\n}\r\n", ""]);

// exports
